<!-- app/layouts/default.vue -->
<template>
  <div class="min-h-screen bg-gray-950 text-gray-100 font-sans">
    <NuxtPage />
  </div>
</template>

<style>
@import url('https://fonts.xz.style/serve/inter.css');
</style>